module.exports = __webpack_public_path__ + "static/media/190x190px_bestallkalibrering.c17e81dc.png";